import React from "react";
import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react"; // Imported MapPin instead of MessageSquare

function ContactBar() {
  return (
    <div className="bg-gradient-to-br from-gray-900 to-black relative overflow-hidden py-8">
      {/* Animated background elements */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        {[...Array(15)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full bg-gray-700/30"
            style={{
              width: `${Math.random() * 60 + 20}px`,
              height: `${Math.random() * 60 + 20}px`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -15, 0],
              x: [0, 10, 0],
            }}
            transition={{
              duration: 15 + Math.random() * 20,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Phone contact */}
          <motion.div
            className="flex items-center bg-gray-800/60 backdrop-blur-sm border border-gray-700 rounded-xl p-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="bg-red-500/20 p-3 rounded-full mr-4">
              <Phone className="w-6 h-6 text-red-400" />
            </div>
            <div className="contact-info">
              <h4 className="text-sm font-medium text-gray-300 mb-1">
                Give Us A Call
              </h4>
              <a
                href="tel:+447795565904"
                className="text-white font-medium hover:text-red-400 transition-colors"
              >
                +44 7795 565904
              </a>
            </div>
          </motion.div>

          {/* Email contact */}
          <motion.div
            className="flex items-center bg-gray-800/60 backdrop-blur-sm border border-gray-700 rounded-xl p-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <div className="bg-red-500/20 p-3 rounded-full mr-4">
              <Mail className="w-6 h-6 text-red-400" />
            </div>
            <div className="contact-info">
              <h4 className="text-sm font-medium text-gray-300 mb-1">
                Send Us A Message
              </h4>
              <a
                href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=new"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white font-medium hover:text-red-400 transition-colors"
              >
                info@aaidank.com
              </a>
            </div>
          </motion.div>

          {/* Location contact - REPLACED WHATSAPP */}
          <motion.div
            className="flex items-center bg-gray-800/60 backdrop-blur-sm border border-gray-700 rounded-xl p-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <div className="bg-red-500/20 p-3 rounded-full mr-4">
              <MapPin className="w-6 h-6 text-red-400" />{" "}
              {/* Changed icon to MapPin */}
            </div>
            <div className="contact-info">
              <h4 className="text-sm font-medium text-gray-300 mb-1">
                Our Location
              </h4>{" "}
              {/* Changed heading */}
              <a
                // A Google Maps link for "Kent UK"
                href="https://www.google.com/maps/place/Kent"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white font-medium hover:text-red-400 transition-colors"
              >
                Kent UK {/* Changed text */}
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Decorative elements */}
      <motion.div
        className="absolute top-1/4 left-1/4 w-40 h-40 rounded-full bg-red-900/20 blur-xl"
        animate={{
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
    </div>
  );
}

export default ContactBar;
